import {
  Alignment,
  Button,
  Classes,
  Dialog,
  FormGroup,
  HTMLSelect,
  HTMLTable,
  InputGroup,
  Switch,
  Tooltip,
} from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { ICalc, IContestacaoCalcCalculados, IContestacaoLoteCalculados, IProdutos, newIProdutos } from "../../model";
import { CalcStore } from "../../stores/calculo/CalcStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { getMomentFormatter, groupBy } from "../../utils";
import MomentLocaleUtils from "react-day-picker/moment";
import { CalcRSStore } from "../../stores/calculo-rs/CalcRSStore";
import { toast } from "react-toastify";
import { AppStore } from "../../stores/AppStore";
import { CalcSelect, filterCalcs, renderCalcs } from "../utils/CalcSelect";
import { AppIcon } from "../utils/AppIcon";
import InfoModal from "../info-modal/InfoModal";
import { MDBCol, MDBRow } from "mdbreact";

interface ContestarLoteProdutosDialogProps {
  items: IContestacaoCalcCalculados[];
  tipo: string;
  modelo: string;
  estado: string;
  onClose: (reload?: boolean) => void;
}

interface ContestarLoteProdutosDialogState {
}

@observer
export class ContestarLoteProdutosDialog extends React.Component<ContestarLoteProdutosDialogProps, ContestarLoteProdutosDialogState> {

  obs = observable({
    contestacao: {} as IContestacaoLoteCalculados,
    produto: newIProdutos() as IProdutos,
    memoria_salvar: false as boolean,
    retroativas: true as boolean,
    aplicar_retencao: false as boolean,
    isDevolucao: false,
    calc_selecionado: null,
    calc_devolucao_selecionado: null,
    itens: [],
    cnpj_memoria: true as boolean,
    open_ajuda: false as boolean
  })

  constructor(props: any) {
    super(props);
    if (this.props.estado == "RS") {
      CalcRSStore.load();
    } else {
      CalcStore.load();
    }

    this.obs.itens = [...this.props.items]

    this.obs.contestacao = observable({
      nota_item_ids: [],
      motivo: "",
      contestacao_calc_id: null,
      contestacao_data: null,
      entrada_saida: this.props.tipo.toLocaleLowerCase(),
      modelo: "nf-e",
      produto: this.props.items?.map(value => value.produtos),
      valor_contestado: 0.0
    });
  }

  handleConfirm = async () => {
    ResultadoStore.obs.working = true
    ResultadoStore.obs.ids_contestacao_all = []

    if (ResultadoStore.obs.contestar_todos && !ResultadoStore.obs.notasRetroativas && !ResultadoStore.obs.notasDivergentes && !ResultadoStore.obs.notasManual) {
      this.obs.itens = []
      this.obs.contestacao.entrada_saida = ""

      await ResultadoStore.handleResultMemoriaFilteredAll(this.props.estado)

      this.obs.itens = [...ResultadoStore.obs.ids_contestacao_all]

      if (!window.confirm("Você está prestes a contestar " + this.obs.itens.length + " itens." + "\nObs: Itens que já estão em processo são ignorados!")) {
        this.props.onClose()
        return
      }

      ResultadoStore.obs.ids_contestacao_all = []

    }

    this.obs.contestacao.produto = this.obs.produto;

    let devolucao = false

    if (this.obs.aplicar_retencao) {

      if (!this.obs.calc_devolucao_selecionado._id) {
        toast.warning('Por favor, selecione um cálculo para a retenção.', {});
        ResultadoStore.obs.working = false
        return;
      }

      this.obs.contestacao.contestacao_calc_id_devolucao = this.obs.calc_devolucao_selecionado._id
      this.obs.contestacao.contestacao_calc_id = this.obs.calc_selecionado._id

      devolucao = true

    } else {

      delete this.obs.contestacao.contestacao_calc_id_devolucao
      this.obs.contestacao.contestacao_calc_id = this.obs.calc_selecionado._id

      devolucao = false

    }

    const gruped = groupBy(this.obs.itens, "entrada_saida")

    Object.keys(gruped).map(value => {

      const dados = gruped[value]

      const destino_origem = groupBy(dados, value == "entrada" ? "cnpj_destino" : "cnpj_origem")

      Object.keys(destino_origem).map(async cnpj => {

        const dados2 = destino_origem[cnpj]

        this.obs.contestacao.nota_item_ids = dados2.map(x => x.id)
        this.obs.contestacao.entrada_saida = value

        await ResultadoStore.create_contestacao_task(this.obs.contestacao, this.obs.memoria_salvar, this.props.estado.toLowerCase(), devolucao, cnpj, null, null, this.obs.cnpj_memoria)

      })

    })

    ResultadoStore.consulta_resultados_calculo()

    this.props.onClose();

  };

  getProduto(id: string) {
    this.obs.contestacao.produto?.map(el => {
      if (Array.isArray(el)) {
        for (let i: number = 0; i < el.length; i++) {
          if (el[i].id == id) {
            this.obs.produto = el[i];
            return;
          }
        }
      } else {
        this.obs.produto = el;
        return;
      }
    })
  }

  handleFilterCalcs(calcs: any, tmp_tipo: string, tmp_modelo: string) {

    let calc_options = []

    calc_options = calcs?.map((calc: ICalc) => {

      if (calc[tmp_tipo] == true && calc[tmp_modelo] == true) {

        return calc

      }

      return null

    }).filter(option => option !== null);

    return calc_options

  }

  handleValidDevolucao() {
    let calcOptions: any = []

    if (ResultadoStore.obs.empresaContestar.uf == "RS") {

      calcOptions = CalcRSStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    } else {

      calcOptions = CalcStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    }

  }

  render() {

    let tmp_tipo = this.props.tipo.toLowerCase().replace("í", "i");
    let tmp_modelo = this.props.modelo.toLowerCase().replace("-", "");

    let calcOptions: any = []
    let calcOptionsRetro: any = []
    let calcOptionsRetencao: any = []
    let produtoOptions: any = [];

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    if (this.props.items.length > 0) {

      if (this.props.estado == "RS") {

        calcOptions = this.handleFilterCalcs(CalcRSStore.validForDate(), tmp_tipo, tmp_modelo)
        calcOptionsRetro = this.handleFilterCalcs(CalcRSStore.validForDateRetro(), tmp_tipo, tmp_modelo)

      } else {

        calcOptions = this.handleFilterCalcs(CalcStore.validForDate(), tmp_tipo, tmp_modelo)
        calcOptionsRetro = this.handleFilterCalcs(CalcStore.validForDateRetro(), tmp_tipo, tmp_modelo)

      }

    }

    const allProdutos = this.props.items?.flatMap((el: any) => el.produtos || []) || [];

    const produtosUnicos = Array.from(
      new Map(allProdutos.map((p: any) => [`${p.cest}-${p.aliquota}`, p])).values()
    );

    produtoOptions = produtosUnicos.map((value: any) => (
      <option key={`${value.cest}-${value.aliquota}`} value={value.id}>
        {`Cest: ${value.cest} - Alíquota: ${value.aliquota} - Descrição: ${value.descricao.substring(0, 50)}...`}
      </option>
    ));

    produtoOptions.push(<option value="selecione">Selecione o produto correto...</option>);
    produtoOptions.reverse();

    calcOptionsRetencao = CalcStore.validForDate()?.map((calc: ICalc) => {

      if (calc["saida"] == true && calc[tmp_modelo] == true) {

        return calc

      }

      return null

    }).filter(option => option !== null);

    let calcText = !this.obs.calc_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_selecionado.nome.length >= 80 ? this.obs.calc_selecionado.nome.substring(0, 80) + "..." : this.obs.calc_selecionado.nome}`
    let devolucaoText = !this.obs.calc_devolucao_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_devolucao_selecionado.nome.length >= 80 ? this.obs.calc_devolucao_selecionado.nome.substring(0, 80) + "..." : this.obs.calc_devolucao_selecionado.nome}`

    return (
      <>
        <Dialog
          isOpen={true}
          onClose={() => this.props.onClose()}
          style={{ width: 800, maxHeight: 520 }}
        >
          <div className={Classes.DIALOG_HEADER}>
            <div style={{ display: "flex", width: "100%" }}>
              <h2 className="title-no-bottom">Contestar Cálculo</h2>
              {this.obs.isDevolucao && tmp_tipo == "entrada" && AppStore.obs1.selectedEmpresa.simples_nacional && (tmp_modelo.toLowerCase() == "nfe" || tmp_modelo.toLowerCase() == "nfce") &&
                <Switch
                  label={"Aplicar retenção na saída?"}
                  checked={this.obs.aplicar_retencao}
                  onChange={(e: any) => this.obs.aplicar_retencao = e.target.checked}
                  style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
                />
              }
            </div>
          </div>
          <div className={Classes.DIALOG_BODY}>
            <HTMLTable
              className="table table-hover dataTable"
              style={{ width: "100%" }}
            >
              <tbody>

                <tr>
                  <td style={{ verticalAlign: "middle" }}>Cálculo aplicado</td>
                  <td>
                    <FormGroup className="empresaSelect calcSelectProduto">
                      <CalcSelect
                        items={this.obs.retroativas ? calcOptions : calcOptionsRetro}
                        itemRenderer={renderCalcs}
                        itemPredicate={filterCalcs}
                        onItemSelect={(e: ICalc) => {
                          this.obs.calc_selecionado = e
                          this.handleValidDevolucao()
                        }}
                        inputProps={{ placeholder: "Filtrar um Cálculo" }}
                        matchTargetWidth
                      >
                        <Button
                          text={calcText}
                          rightIcon="double-caret-vertical"
                          alignText={Alignment.LEFT} />
                      </CalcSelect>
                    </FormGroup>
                  </td>
                  <td>
                    <Switch
                      label={this.obs.retroativas ? "Cálculo Vigentes" : "Cálculos Retroativos"}
                      checked={this.obs.retroativas}
                      onChange={(e: any) => this.obs.retroativas = e.target.checked}
                      style={{ marginTop: "10px" }}
                    />
                  </td>
                </tr>
                {this.obs.aplicar_retencao &&
                  <>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>Cálculo da retenção</td>
                      <td>
                        <FormGroup className="empresaSelect calcSelect">
                          <CalcSelect
                            items={calcOptionsRetencao}
                            itemRenderer={renderCalcs}
                            itemPredicate={filterCalcs}
                            onItemSelect={(e: ICalc) => this.obs.calc_devolucao_selecionado = e}
                            inputProps={{ placeholder: "Filtrar um Cálculo" }}
                            matchTargetWidth
                          >
                            <Button
                              text={devolucaoText}
                              rightIcon="double-caret-vertical"
                              alignText={Alignment.LEFT} />
                          </CalcSelect>
                        </FormGroup>
                      </td>
                      <td />
                    </tr>
                  </>
                }
                <tr>
                  <td style={{ verticalAlign: "middle" }}>Produto</td>
                  <td>
                    <HTMLSelect
                      onChange={(e: any) => this.getProduto(e.target.value)}
                      value={this.obs.produto.id}
                    >
                      {produtoOptions}
                    </HTMLSelect>
                  </td>
                  <td />
                </tr>

                <tr>
                  <td style={{ verticalAlign: "middle" }}>
                    Alterar data
                  </td>
                  <td>
                    <DateInput
                      {...getMomentFormatter("DD/MM/YYYY")}
                      locale="pt-br"
                      dayPickerProps={dayPickerProps}
                      value={this.obs.contestacao.contestacao_data
                        ? new Date(this.obs.contestacao.contestacao_data)
                        : null}
                      onChange={val => this.obs.contestacao.contestacao_data = val}
                      placeholder="DD/MM/AAAA"
                      canClearSelection
                    />
                  </td>
                  <td />

                </tr>
                <tr>
                  <td style={{ verticalAlign: "middle" }}>Motivo</td>
                  <td>
                    <InputGroup
                      value={this.obs.contestacao.motivo}
                      onChange={(e: any) =>
                        this.obs.contestacao.motivo = e.target.value}
                    />
                  </td>
                  <td />
                </tr>
              </tbody>
            </HTMLTable>

            <MDBRow>
              <MDBCol md="3">
                <div className="consteta-produto-lote-btn">
                  <Switch
                    label={"Salvar contestação"}
                    alignIndicator={Alignment.RIGHT}
                    innerLabelChecked="Sim"
                    innerLabel="Não"
                    checked={this.obs.memoria_salvar}
                    onChange={(e: any) => this.obs.memoria_salvar = e.target.checked}
                  />
                  {this.obs.memoria_salvar &&
                    <div style={{ display: "flex" }}>
                      <label style={{ width: 140 }}>
                        Memória CNPJ
                        <AppIcon
                          name="help"
                          className="pulse-notification-pgdas"
                          color="blue"
                          style={{ cursor: "pointer", marginLeft: 5 }}
                          onClick={(e) => this.obs.open_ajuda = true}
                        />
                      </label>
                      <Switch
                        alignIndicator={Alignment.RIGHT}
                        innerLabelChecked="Sim"
                        innerLabel="Não"
                        checked={this.obs.cnpj_memoria}
                        onChange={(e: any) => this.obs.cnpj_memoria = e.target.checked}
                      />
                    </div>
                  }
                </div>
              </MDBCol>

              <MDBCol md="9" style={{ position: "relative"}}>
                <div className="consteta-produto-lote-btn" style={{position: "absolute", bottom: 0, right: 0, textAlign: "right" }}>
                  <Button text="Cancelar" onClick={() => this.props.onClose()} style={{ marginRight: 10, height: "35px" }} />
                  <Button
                    text="Contestar"
                    intent="primary"
                    onClick={this.handleConfirm}
                    loading={ResultadoStore.obs.working}
                    disabled={!this.obs.calc_selecionado?._id || !this.obs.contestacao.motivo}
                    style={{ height: "35px" }}
                  />
                </div>
              </MDBCol>
            </MDBRow>

          </div>
        </Dialog>

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`

          <b>Memória CNPJ:</b><br /><br />

          <b>Ativada</b> – O sistema valida o CNPJ de origem nas entradas e o CNPJ de destino nas saídas para salvar a Memória de Cálculo.<br /><br />

          <b>Desativada</b> – O sistema não realiza a validação de CNPJ, permitindo salvar a Memória de Cálculo sem informações de CNPJ.<br /><br />

        `} />

      </>
    );
  }
}
